import CancellationRequestObject from "~/records/record.cancellationRequestObject.jsx";
import * as actionTypes from "~/store/action_types";

const cancellationRequestObject = (state = new CancellationRequestObject(), action) => {
  switch (action.type) {
    case actionTypes.CREATE_CANCELLATION_REQUEST_LOADING:
      return state;

    case actionTypes.CREATE_CANCELLATION_REQUEST_SUCCESS:
      return new CancellationRequestObject({
        ...state.toObject(),
        ...action.response.cancellation_request,
      });

    case actionTypes.GET_ACCOUNT_STATS_BEFORE_CANCELLATION_ERROR:
      return state;

    default:
      return state;
  }
};

export default cancellationRequestObject;
